module.exports = __webpack_public_path__ + "img/IMG-20191124-WA0025.31246dcf.jpg";